import helper from './helper';

class VMenu {
    constructor() {
        let _this = this;
        $(document).on('click', '.v-menu__toggle', function () {
            let el = $(this).siblings('.v-menu');
            if (el.is(':visible')) {
                _this.hide(el);
            } else {
                _this.show(el);
            }
        });
    }

    show(el) {
        el.closest('li').addClass('v-menu__expanded');
        helper.slideDown(el, 0.1);
    }

    hide(el) {
        el.closest('li').addClass('v-menu__expanding');
        helper.slideUp(el, 0.1, () => {
            el.closest('li').removeClass('v-menu__expanded v-menu__expanding');
        });
    }
}

export const vMenu = new VMenu();
